import { render } from "./OrderPaySuccess.vue?vue&type=template&id=fc142ace"
import script from "./OrderPaySuccess.vue?vue&type=script&lang=js"
export * from "./OrderPaySuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__